/**
 * Home Group New Header JS Include
 *
 * @author Strange Animals <info@strangeanimals.com.au>
 */

/*$(document).on('click', '.menu-toggle', function() {
    $(this).css('background-color', 'pink');
});*/

$(document).ready(function() {
  // Toggle Menu on click
  $('.menu-toggle').click(function() {
      $('html').toggleClass('open-menu');
      $('.mobile-menu').slideToggle(700, function() {
          if ($(this).is(':visible')) $(this).css('display', 'flex');
          $(this).toggleClass('menu-open');
      });
  });

  // Toggle Menu on window resize to close open menus
  $(window).resize(function() {
      let htmlElement = document.querySelector('html');

      if ($(window).width() > 960 && htmlElement.classList.contains('open-menu')) {
          $('html').toggleClass('open-menu');
          $('.mobile-menu').slideToggle(700, function() {
              if ($(this).is(':visible')) $(this).css('display', 'flex');
              $(this).toggleClass('menu-open');
          });
      }
  });
});

